import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { errorNormalizer } from '../../shared/Helpers/functions';
import { useCheckPermission } from '../../shared/Helpers/hooks';
import { PERMISSIONS } from '../../App/constants';
import { STROKE } from '../../shared/Helpers/colors';
import { isImpersonating as checkIsImpersonating } from '../../redux/API/Main/fetchAPI';
import AccountDetails from './accountDetails';
import { AdminTypes } from '../Menu';
import Delete from '../Delete';

import { DispatchProperties, useSelector } from '../../redux/store';
import { UserProperties } from '../../redux/API/userAPIProperties';
import { deleteUser } from '../../redux/State/userSlice';
import { impersonate } from '../../redux/State/identitySlice/accountSlice';
import { EditSvg } from '../../shared/Assets/svgIcons';

const UserAction = ({
	item,
	fetchUsers,
	hideMoreInfo = false,
}: {
	fetchUsers: () => void;
	hideMoreInfo?: boolean;
	item: UserProperties;
}) => {
	const dispatch = useDispatch<DispatchProperties>();
	const navigate = useNavigate();
	const EDIT = useCheckPermission(PERMISSIONS.USER.EDIT);
	const DELETE = useCheckPermission(PERMISSIONS.USER.DELETE);
	const role = useSelector((state) => state.account.role);
	const canImpersonate = role?.claims.some((claim) => claim.claimValue === PERMISSIONS.USER.IMPERSONATE);
	const impersonating = checkIsImpersonating();
	const { pathname } = useLocation();

	const onDeleteClick = (id: string) => {
		dispatch(deleteUser(id))
			.then(unwrapResult)
			.then(() => {
				toast(`Deleted`);
				fetchUsers();
			})
			.catch(errorNormalizer);
	};

	const onEditClick = () => {
		const roleType = item.role.section.id;
		if (typeof roleType !== 'number') return;
		window.localStorage.setItem('formType', AdminTypes[roleType]);
	};

	const onImpersonateClick = () => {
		dispatch(impersonate(item.id))
			.then(unwrapResult)
			.catch(errorNormalizer);
	};

	return (
		<div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
			{DELETE.permissionGranted && <Delete deleteHandler={() => onDeleteClick(item.id)} />}
			{EDIT.permissionGranted && (
				<Link to={`${pathname}/${item.id}`}>
					<Tooltip title="Edit">
						<div onClick={onEditClick}>
							<EditSvg />
						</div>
					</Tooltip>
				</Link>
			)}
			{!hideMoreInfo && <AccountDetails item={item} />}
			{canImpersonate && !impersonating && (
				<Tooltip title="Impersonate">
					<button
						onClick={onImpersonateClick}
						style={{
							background: 'none',
							border: `1px solid ${STROKE.PRIMARY}`,
							borderRadius: '4px',
							padding: '4px 8px',
							cursor: 'pointer',
							fontSize: '12px',
						}}
					>
						Impersonate
					</button>
				</Tooltip>
			)}
		</div>
	);
};

export default UserAction;
